import { render, staticRenderFns } from "./HardwaresGroup.vue?vue&type=template&id=59ef677b"
import script from "./HardwaresGroup.vue?vue&type=script&lang=js"
export * from "./HardwaresGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports